import ModelAttributeCard from '@components/model/details/ModelAttributeCard';
import { Chip } from '@destination/components';
import { IAttributeRef, IAttributes } from '@models/IFunctionality';
import { IRecords } from '@models/IRecord';
import { slugify } from '@utils/text-utils';
import { useTranslation } from 'react-i18next';
import { FunctionalityAttributeDetail } from './FunctionalityAttributeDetail';

export interface IFunctionalityAttributesList {
  attributes: IAttributes;
  records: IRecords;
  'data-testid'?: string;
}

export const FunctionalityAttributesList = ({
  attributes,
  records,
  'data-testid': dataTestId
}: IFunctionalityAttributesList) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'model.functionality.attributes'
  });

  const titleComponent = (name: string, attributeRef: IAttributeRef) => (
    <div className="flex items-center w-full justify-between">
      <div className="tw-text-base w-1/4">{name}</div>
      <div className="flex items-center w-1/4">
        {attributeRef.readonly ? (
          <Chip className="bg-[#ff9991]" label={t('readonly')} />
        ) : (
          <Chip className="bg-[#b9ff91]" label={t('writeable')} />
        )}
      </div>
      <div className="flex items-center w-2/4">
        <Chip label={attributeRef.$ref} />
      </div>
    </div>
  );

  return (
    <div data-testid={dataTestId}>
      {Object.keys(attributes).map(attributeName => {
        return (
          <ModelAttributeCard
            variant="LIGHT"
            key={slugify(attributeName)}
            title={titleComponent(attributeName, attributes[attributeName])}
          >
            <div className="p-3 bg-slate-50">
              <FunctionalityAttributeDetail
                attribute={attributes[attributeName]}
                records={records}
              />
            </div>
          </ModelAttributeCard>
        );
      })}
    </div>
  );
};
